import { Paper, Typography, useTheme } from '@mui/material'

const CURRICULUM_URL =
  process.env.REACT_APP_CURRICULUM_URL || 'https://hiv.uw.edu'

export const SiteInfo: React.FC = () => {
  const theme = useTheme()

  return (
    <Paper
      sx={{
        padding: '16px',
        textAlign: 'left',
        color: theme.palette.text.secondary,
        height: '100%',
      }}
      elevation={1}
    >
      <Typography variant="h5" gutterBottom>
        About the National HIV Curriculum Comprehensive Knowledge Assessment
        Certificate
      </Typography>
      <Typography variant="body1" paragraph>
        This application provides assessments to{' '}
        <a href={CURRICULUM_URL}>National HIV Curriculum</a> learning groups
        members.
      </Typography>
      <Typography variant="body1" paragraph>
        <strong>How to access: </strong>
        <br />
        To access this assessment application,{' '}
        <strong>
          sign in using your National HIV Curriculum username and password
        </strong>
        .
      </Typography>
      <Typography variant="subtitle1" paragraph>
        <strong>
          Need help getting set up to review questions?
          <br />
        </strong>{' '}
        Contact <a href="mailto:jfy@uw.edu">John Young</a> on the IDEA
        Development Team
      </Typography>
    </Paper>
  )
}

export default SiteInfo
